import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import BasicImage from '../DebtPaymentComponents/basicImage';
import UpdatePaymentMethodNotification from '../DebtPaymentComponents/updatePaymentMethodNotification';
import Action from '../DebtPaymentComponents/action';
import {errorEnum, followUpEnum, stepEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import Config from '../../../../Config';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {numWithStarRTL} from '../../../../utilities/StringHelpers/StringHelpers';
import {CSSTransition} from 'react-transition-group';
import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';
import {report, getReportParams} from '../../../../middleware/report';

const PaymentError = (props) => {
  const [mount, setMount] = useState(false);

  useEffect(() => {
    if (props.currentStep === errorEnum.PAYMENTFAILED) {
      setMount(true);
      if (props.isPrivate) {
        gaEvent(
          gaParams.PRIVATEDEBT_PAYMENTFAIL_SHOW.category,
          gaParams.PRIVATEDEBT_PAYMENTFAIL_SHOW.eventType,
          gaParams.PRIVATEDEBT_PAYMENTFAIL_SHOW.eventParams,
        );

        let reportParams = getReportParams();
        reportParams.area = 'SelfCare';
        reportParams.subArea = 'Private Debt Payment';
        reportParams.channel = 'WebsitePrivate';
        reportParams.actionType = 'Credit Card Payment Details Page';
        reportParams.banId = props.savedCustomerData?.number;
        reportParams.idNumber = props.savedCustomerData?.idNumber;
        reportParams.status = 'Error';
        reportParams.messageText = 'General Error';
        reportParams.subscriber = props.phoneNumber;
        reportParams.param1 = 'סה"כ יתרה: ' + parseFloat(props.debtAmount) + '₪';
        reportParams.param2 = `סכום לתשלום: ${props.privateAmount}₪`;
        reportParams.customerName = props.savedCustomerData?.name;
        report(reportParams);
      } else {
        if (props.noPaymentMethod) {
          gaEvent(
            gaParams.DEBT_PAYMENT_SHOW_PAMENTERROR_WITHPMNTMETHODLNK.category,
            gaParams.DEBT_PAYMENT_SHOW_PAMENTERROR_WITHPMNTMETHODLNK.eventType,
            gaParams.DEBT_PAYMENT_SHOW_PAMENTERROR_WITHPMNTMETHODLNK.eventParams,
          );
        } else {
          gaEvent(
            gaParams.DEBT_PAYMENT_SHOW_PAMENTERROR_NOPMNTMETHODLNK.category,
            gaParams.DEBT_PAYMENT_SHOW_PAMENTERROR_NOPMNTMETHODLNK.eventType,
            gaParams.DEBT_PAYMENT_SHOW_PAMENTERROR_NOPMNTMETHODLNK.eventParams,
          );
        }
      }
    } else {
      setMount(false);
    }
  }, [props.currentStep]);

  let number = props.isPrivate ? Config.financeCallNumber1 : Config.businessCallNumber;
  let text = props.isPrivate
    ? props.isMobile
      ? 'ניתן לנסות שוב במועד מאוחר יותר או לפנות\nלנציג פיננסי בהתאם לשעות פעילות המוקד'
      : 'ניתן לנסות שוב במועד מאוחר יותר או לפנות לנציג פיננסי בהתאם לשעות פעילות המוקד'
    : props.isMobile
    ? 'לבירורים נוספים באפשרותך לפנות \n לאחראי השירות שלך'
    : 'לבירורים נוספים באפשרותך לפנות לאחראי השירות שלך';
  let mainImg = require('../images/icons-error.svg');
  let dial = require('../images/icons-call-phone.svg');
  let actionText = props.isMobile ? 'חיוג ' + numWithStarRTL(number) + 'לאחראי שירות' : 'לפנייה לנציג שירות יש לחייג למספר ';
  const errorImgComponent = props.isPrivate ? (
    <Row className='justify-content-md-center main-img'>
      <Col md='auto'>
        <BasicImage src={mainImg} />
      </Col>
    </Row>
  ) : null;

  const actionOnClick = (e) => {
    if (props.isPrivate) {
      gaEvent(
        gaParams.PRIVATEDEBT_PAYMENTFAIL_CALL_CLICK.category,
        gaParams.PRIVATEDEBT_PAYMENTFAIL_CALL_CLICK.eventType,
        gaParams.PRIVATEDEBT_PAYMENTFAIL_CALL_CLICK.eventParams,
      );
    } else {
      if (props.noPaymentMethod) {
        gaEvent(
          gaParams.DEBT_PAYMENT_CLICK_PAMENTERROR_DIAL_WITHPMNTMETHODLNK.category,
          gaParams.DEBT_PAYMENT_CLICK_PAMENTERROR_DIAL_WITHPMNTMETHODLNK.eventType,
          gaParams.DEBT_PAYMENT_CLICK_PAMENTERROR_DIAL_WITHPMNTMETHODLNK.eventParams,
        );
      } else {
        gaEvent(
          gaParams.DEBT_PAYMENT_CLICK_PAMENTERROR_DIAL_NOPMNTMETHODLNK.category,
          gaParams.DEBT_PAYMENT_CLICK_PAMENTERROR_DIAL_NOPMNTMETHODLNK.eventType,
          gaParams.DEBT_PAYMENT_CLICK_PAMENTERROR_DIAL_NOPMNTMETHODLNK.eventParams,
        );
      }
    }
    window.open('tel:' + e);
  };

  const setCodeAndHandleStep = (step) => {
    if (props.isPrivate) {
      gaEvent(
        gaParams.PRIVATEDEBT_PAYMENTFAIL_CONTACTME_INIT_CLICK.category,
        gaParams.PRIVATEDEBT_PAYMENTFAIL_CONTACTME_INIT_CLICK.eventType,
        gaParams.PRIVATEDEBT_PAYMENTFAIL_CONTACTME_INIT_CLICK.eventParams,
      );
    } else {
      if (props.noPaymentMethod) {
        gaEvent(
          gaParams.DEBT_PAYMENT_CLICK_PAMENTERROR_CONTACTUS_WITHPMNTMETHODLNK.category,
          gaParams.DEBT_PAYMENT_CLICK_PAMENTERROR_CONTACTUS_WITHPMNTMETHODLNK.eventType,
          gaParams.DEBT_PAYMENT_CLICK_PAMENTERROR_CONTACTUS_WITHPMNTMETHODLNK.eventParams,
        );
      } else {
        gaEvent(
          gaParams.DEBT_PAYMENT_CLICK_PAMENTERROR_CONTACTUS_NOPMNTMETHODLNK.category,
          gaParams.DEBT_PAYMENT_CLICK_PAMENTERROR_CONTACTUS_NOPMNTMETHODLNK.eventType,
          gaParams.DEBT_PAYMENT_CLICK_PAMENTERROR_CONTACTUS_NOPMNTMETHODLNK.eventParams,
        );
      }
    }
    props.setFollowUpData({
      followUpType: followUpEnum.PaymentFailed,
      title: 'השאירו פרטים ונחזור אליכם',
      text: 'צוות השירות שמטפל בכם יעודכן בסיבת הפניה',
    });
    props.handleCurrentStep(step);
  };

  const arrow = require('../images/icons-arrow.svg');

  return (
    <CSSTransition key={16} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step'>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='אופס.. התשלום נכשל' classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        <Row className='debtpayment-step-subtitle justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={text} />
          </Col>
        </Row>
        {props.isMobile ? (
          <Action text={actionText} img={dial} num={number} onclick={actionOnClick} fnParams={number} bold />
        ) : (
          <Row className='justify-content-md-center'>
            <Col>
              <BasicText text={actionText + numWithStarRTL(number)} />
            </Col>
          </Row>
        )}
        <Row className='justify-content-md-center'>
          <Col md='auto'>
            <div
              onClick={() => {
                setCodeAndHandleStep(stepEnum.CONTACTUS);
              }}
              className='debtpayment-contactus-button'>
              <BasicText text={props.buttonText} bold color='businessPurple' />
              <BasicImage src={arrow} classname='arrow-img' />
            </div>
          </Col>
        </Row>
        {props.noPaymentMethod && (
          <Row className='justify-content-md-center'>
            <Col lg='4' className={props.isMobile ? '' : 'pr-0 pl-0'}>
              <UpdatePaymentMethodNotification updatePaymentMethod={props.updatePaymentMethod} />
            </Col>
          </Row>
        )}
        {errorImgComponent}
        <Row className='justify-content-md-center footer-btn'>
          <Col md='auto'>
            <BtnSubmit isBusiness={!props.isPrivate} formid='' text='סיום' onclick={props.onclick} />
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default PaymentError;
